exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-accordion[data-v-32b06589]{transition:all .4s ease-in-out;overflow-x:hidden}.container-open[data-v-32b06589]{overflow-y:hidden;max-height:900px}.container-close[data-v-32b06589]{overflow-y:hidden;max-height:120px}.formasenvio[data-v-32b06589]{height:30px;width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32b06589","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms-loja/config-selformasenvio-form-loja.vue
// module id = 1943
// module chunks = 0